<template>
  <a-modal
    title="详情查看"
    width="1200px"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
    wrapClassName="ant-modal-cust-warp"
    style="top:30%;height: 55%;overflow-y: hidden">
    <a-descriptions
      title="发货信息"
      bordered
      :column="{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }"
    >
      <a-descriptions-item label="发货编号">
        {{data.number}}
      </a-descriptions-item>
      <a-descriptions-item label="单据日期">
        {{data.operTime}}
      </a-descriptions-item>
      <a-descriptions-item label="出库单号">
       {{data.linkHeadNumber}}
      </a-descriptions-item>
      <a-descriptions-item label="客户名称">
       {{data.organName}}
      </a-descriptions-item>
      <a-descriptions-item label="联系人">
        {{data.contacts}}
      </a-descriptions-item>
      <a-descriptions-item label="联系电话">
        {{data.phoneNum}}
      </a-descriptions-item>
      <a-descriptions-item label="送货地址">
        {{data.address}}
      </a-descriptions-item>
      <a-descriptions-item label="运费金额(元)">
        {{data.totalPrice}}
      </a-descriptions-item>
      <a-descriptions-item label="承运人">
        {{data.carrier}}
      </a-descriptions-item>
      <a-descriptions-item label="承运人电话">
        {{data.carrierMobile}}
      </a-descriptions-item>
      <a-descriptions-item label="车号">
        {{data.carNo}}
      </a-descriptions-item>
      <a-descriptions-item label="发货时间">
        {{data.deliveryTime}}
      </a-descriptions-item>
      <a-descriptions-item label="预计到达时间">
        {{data.arrivalTime}}
      </a-descriptions-item>
      <a-descriptions-item label="制单人">
        {{data.preparer}}
      </a-descriptions-item>
      <a-descriptions-item label="配货人">
        {{data.distributor}}
      </a-descriptions-item>
      <a-descriptions-item label="备注">
        {{data.remark}}
      </a-descriptions-item>
    </a-descriptions>

    <div class="ant-descriptions-title"   style="margin-top: 20px ">发货清单</div>
    <a-table
      ref="table"
      size="middle"
      bordered
      rowKey="id"
      :columns="columns1"
      :dataSource="dataSource1"
      :pagination="false"
    >
    </a-table>
    <a-form-model-item label="附件" v-if="data.fileName">
      <j-upload v-model="data.fileName" bizPath="bill" :disabled="true" :buttonVisible="false"></j-upload>
    </a-form-model-item>
    <div class="ant-descriptions-title"   style="margin-top: 20px ">物流跟踪</div>
    <a-table
      style="margin-top: 10px "
      ref="table"
      size="middle"
      bordered
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="false"
    >
    </a-table>
  </a-modal>

</template>
<script>
import { Logistics } from '@api/logistics'
import JUpload from '@comp/jeecg/JUpload'
export default {
  name: "LogisticsDetailModal",
  mixins: [],
  components: {
    JUpload
  },
  data() {
    return {
      confirmLoading:false,
      visible: false,
      dataSource:[],
      dataSource1:[],
      data:{},
      // 表头
      columns: [
        { title: '序号', dataIndex: '', key: 'rowIndex', width: 50, align: "center", customRender: function (t, r, index) {return parseInt(index) + 1;}},
        { title: '物流时间', dataIndex: 'logisticsTime',align: "center",width:300, ellipsis:true },
        { title: '地点', dataIndex: 'address',align: "center",width:120, ellipsis:true },
        { title: '更新人', dataIndex: 'creator',align: "center",width:120, ellipsis:true },
      ],
      columns1: [
        { title: '序号', dataIndex: '', key: 'rowIndex', width: 50, align: "center", customRender: function (t, r, index) {return parseInt(index) + 1;}},
        { title: '条码', dataIndex: 'barCode',align: "center",width:120, ellipsis:true},
        { title: '名称', dataIndex: 'name',align: "center",width:120, ellipsis:true},
        { title: '规格', dataIndex: 'standard',align: "center",width:120, ellipsis:true},
        { title: '单位', dataIndex: 'unit',align: "center",width:120, ellipsis:true},
        { title: '数量', dataIndex: 'operNumber',align: "center",width:120, ellipsis:true},
        { title: '备注', dataIndex: 'remark',align: "center",width:120, ellipsis:true}
      ],
      labelCol: {},
      wrapperCol: {},
      cardStyle: '',
    }
  },
  methods: {
    handleOk(){
      this.handleCancel()
    },
    handleCancel(){
      this.visible = false
    },
    show(record){
      this.visible = true
      Logistics.detail(record.id).then(res => {
        let values = res.data
        this.data = values
        this.dataSource = values.items
        return values
      }).then( values => {
        Logistics.headItems({headerId: values.linkHeadId}).then(res => {
          this.dataSource1 = res.data.rows
        })
      })
    },
  }
}


</script>